import _ from 'lodash';
import { saveAs } from 'file-saver';
import { loadPayment } from 'researcher/payment/actions';
import { loadUserInvoicingData } from 'researcher/user/actions';
import * as c from './constants';
export var archiveDigitalEdit = function archiveDigitalEdit(digitalEditIdentity, fileName) {
  var removeOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.post("/api/digital-edit/".concat(digitalEditIdentity, "/archive"))).then(function () {
      if (removeOnSuccess) {
        dispatch(removeDigitalEdit(digitalEditIdentity));
      }
      dispatch(application.addMessage({
        type: 'success',
        message: '%(fileName)s deleted',
        params: {
          fileName: fileName
        }
      }));
    });
  };
};
export var createDigitalEdit = function createDigitalEdit(digitalEditUpdateRequest) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    return dispatch(application.post('/api/digital-edit/create', digitalEditUpdateRequest)).then(function (json) {
      var error = json.error;
      if (error) {
        if (showError) {
          dispatch(application.addMessage({
            type: 'error',
            message: error.error,
            params: JSON.parse(error.getJsonEncodedParams() || '{}')
          }));
        }
      } else if (searchOnSuccess) {
        // If we successfully upload a digital edit, let's add it to the page
        dispatch(searchDigitalEdits({
          page: 1
        }));
      }
      return json;
    });
  };
};
export var getDownloadUrl = function getDownloadUrl(digitalEditIdentity, fileName) {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    var handleError = function handleError() {
      dispatch(application.addMessage({
        type: 'error',
        message: 'curie.file-archived'
      }));
      dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        digitalEditIdentity: digitalEditIdentity
      });
    };
    var processResponse = function processResponse(response) {
      if (response.type === 'application/json') {
        throw new Error();
      }
      saveAs(response, fileName);
    };
    dispatch({
      type: c.DOWNLOAD_URL_REQUESTED,
      digitalEditIdentity: digitalEditIdentity
    });
    return dispatch(application.req({
      url: "/api/digital-edit/".concat(digitalEditIdentity, "/download"),
      method: 'get',
      responseType: 'blob',
      timeout: 0,
      validateStatus: function validateStatus(status) {
        return status === 200 || status === 404;
      }
    })).then(processResponse).then(function () {
      return dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        digitalEditIdentity: digitalEditIdentity
      });
    }).catch(handleError);
  };
};
export var removeDigitalEdit = function removeDigitalEdit(digitalEditIdentity) {
  return {
    type: c.DIGITAL_EDIT_ARCHIVED,
    digitalEditIdentity: digitalEditIdentity
  };
};
export var searchDigitalEdits = function searchDigitalEdits() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    dispatch({
      type: c.DIGITAL_EDIT_SEARCH_REQUESTED
    });
    return dispatch(application.get('/api/digital-edit/search', data)).then(function (json) {
      var digitalEdits = json.results,
        pagination = json.pagination;
      dispatch({
        type: c.DIGITAL_EDIT_SEARCH_COMPLETED,
        pagination: pagination,
        digitalEdits: digitalEdits
      });
      return digitalEdits;
    });
  };
};
export var updateDisplayedDigitalEdits = function updateDisplayedDigitalEdits(identities) {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    return dispatch(application.get('/api/digital-edit/search', {
      identities: identities
    })).then(function (json) {
      var digitalEdits = json.results;
      var keyedDigitalEdits = _.keyBy(digitalEdits, 'identity');
      dispatch({
        type: c.DIGITAL_EDITS_UPDATED,
        digitalEdits: keyedDigitalEdits
      });
      return true;
    });
  };
};
export var loadDigitalEditing = function loadDigitalEditing() {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    dispatch(loadUserInvoicingData());
    dispatch(loadPayment());
    return dispatch(application.get('/api/digital-edit/load', {})).then(function (json) {
      var availableDigitalPurchases = json.availableDigitalPurchases,
        digitalEditingPurchase = json.digitalEditingPurchase,
        digitalPurchases = json.digitalPurchases,
        hasDigitalEditingPurchase = json.hasDigitalEditingPurchase,
        hasUploadedDigitalEdit = json.hasUploadedDigitalEdit;
      dispatch({
        availableDigitalPurchases: availableDigitalPurchases,
        digitalEditingPurchase: digitalEditingPurchase,
        digitalPurchases: digitalPurchases,
        hasDigitalEditingPurchase: hasDigitalEditingPurchase,
        hasUploadedDigitalEdit: hasUploadedDigitalEdit,
        type: c.DIGITAL_EDIT_DISPLAY_UPDATED
      });
    });
  };
};
export var getLewisVersion = function getLewisVersion(identity) {
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    return dispatch(application.get("/api/digital-edit/".concat(identity, "/lewis-version")));
  };
};